export enum ImageFormats {
    PNG = 'png',
    JPEG = 'jpeg',
    SVG = 'svg',
}

export enum FrameType {
    Browser = 'Browser',
    // Phone = 'Phone',
    None = 'None',
}

export enum CanvasBackgroundTypes {
    Image = 'Image',
    Solid = 'Solid',
    Gradient = 'Gradient',
    None = 'None',
}

export enum Browsers {
    Edge,
    Chrome,
    Firefox,
    Safari,
}